import Axios from 'axios';

import { constants } from '~/config';

export const firebaseClient = Axios.create({
  baseURL: constants.firebaseUrl,
});
